import React from 'react';
import styled from "styled-components";

const Contact = () => {
  return (
    <Container>
      <Wrapper>
        ContactUs/Footer
      </Wrapper>
    </Container>
  )
}

export default Contact;

const Container = styled.div``;
const Wrapper = styled.div``;